import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.96875 5.15853C5.96875 4.61878 6.40634 4.18118 6.9461 4.18118H11.5071C12.0468 4.18118 12.4844 4.61878 12.4844 5.15853V9.39372H6.9461C6.40634 9.39372 5.96875 8.95613 5.96875 8.41637V5.15853ZM12.4843 9.39389H18.0226C18.5624 9.39389 19 9.83148 19 10.3712V13.6291C19 14.1688 18.5624 14.6064 18.0226 14.6064H12.4843V9.39389Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.96875 15.5836C5.96875 15.0439 6.40634 14.6063 6.9461 14.6063H12.4844V18.8414C12.4844 19.3812 12.0468 19.8188 11.5071 19.8188H6.9461C6.40634 19.8188 5.96875 19.3812 5.96875 18.8414V15.5836Z",
		fill: "white"
	})]
});
export default SvgReplit;
